import React, { useContext } from 'react';
import { withRouter } from 'react-router';
import { LocaleContext } from 'shared';

import { Header as HeaderBase, HeaderTitle } from './Header.styles';
import { HeaderProps } from './Header.types';

export const Header = withRouter(({ location }: HeaderProps) => {
  const localeContext = useContext(LocaleContext);

  const renderHeaderTitle = () => (
    <HeaderTitle>{localeContext.formatMessage({ id: 'HEADER.FOR-DEVELOPERS' })}</HeaderTitle>
  );

  return (
    <HeaderBase active={location.pathname} links={[]} title={renderHeaderTitle()}>
      {() => null}
    </HeaderBase>
  );
});
